import { render, staticRenderFns } from "./TarafBadges.vue?vue&type=template&id=374924f3"
import script from "./TarafBadges.vue?vue&type=script&lang=ts"
export * from "./TarafBadges.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports